module.exports = __webpack_public_path__ + "img/line-parent.5ecb0684.png";